"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

require("source-map-support/register");

var _memoryEngine = _interopRequireDefault(require("./memoryEngine"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var defaults = {
  name: 'orbital-frame',
  ps1: '@',
  // symbol used to hail a user
  ps2: '>',
  // symbol used to engage an interaction
  commands: [],
  plugins: [],
  rootUsers: [],
  storageEngine: (0, _memoryEngine.default)()
};
/**
 * The frame exposes the bot and instantiation options to
 * the service host and provides a uniform API between bot types
 */

function frame(adapter, options) {
  var _objectSpread2 = _objectSpread({}, defaults, {}, options),
      name = _objectSpread2.name,
      ps2 = _objectSpread2.ps2,
      commands = _objectSpread2.commands,
      plugins = _objectSpread2.plugins,
      rootUsers = _objectSpread2.rootUsers,
      storageEngine = _objectSpread2.storageEngine;

  var ps1 = adapter.ps1,
      hear = adapter.hear,
      send = adapter.send,
      getUsers = adapter.getUsers,
      getChannels = adapter.getChannels;
  return {
    name: name,
    ps1: ps1,
    ps2: ps2,
    commands: commands,
    plugins: plugins,
    rootUsers: rootUsers,
    hear: hear,
    send: send,
    getUsers: getUsers,
    getChannels: getChannels,
    adapter: adapter,
    // this should only be used in orbital-frame clients since it will be closely bound to the specific adapter
    storageEngine: storageEngine
  };
}

var _default = frame;
exports.default = _default;